import { render, staticRenderFns } from "./hotPlay.vue?vue&type=template&id=0f29abfb&scoped=true&"
import script from "./hotPlay.vue?vue&type=script&lang=js&"
export * from "./hotPlay.vue?vue&type=script&lang=js&"
import style0 from "./hotPlay.vue?vue&type=style&index=0&id=0f29abfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f29abfb",
  null
  
)

export default component.exports